export const SET_PAYMENT = 'SET_PAYMENT'
export const RESET_PAYMENT = 'RESET_PAYMENT'
export const SET_PAYMENT_ID = 'SET_PAYMENT_ID'
export const SET_SUBSCRIPTION = 'SET_SUBSCRIPTION'